import ApiBase from '../ApiBase';

class Waitlist extends ApiBase {
    index = (data = {}) => this.get('/admin/waitlist', data);

    waitlistEntries = (data = {}) => this.get('/admin/waitlist/entries', data);

    attendeesList = (data = {}) => this.get('/admin/waitlist/attendees', data);

    auditLogs = (data = {}) => this.get('/admin/waitlist/audit-logs', data);

    updateUserStatus = (userId, data) => this.patch(`/admin/waitlist/users/${userId}/status`, data);

    reallocate = () => this.post('/admin/waitlist/reallocate', {});

}

export default new Waitlist();


